const jamlMore = () => {
    [...document.querySelectorAll('.jaml-expandable-container')].map((container) => {
        const btn = container.querySelector('.jaml-read-more-btn');
        const hiddenWrapper = container.querySelector('.jaml-hidden-wrapper');

        if (btn && hiddenWrapper) {
            const textMore = btn.getAttribute('data-text-more') || 'more';
            const textLess = btn.getAttribute('data-text-less') || 'less';

            btn.addEventListener('click', (e) => {
                e.preventDefault();


                const isExpanded = container.classList.toggle('is-expanded');


                if (isExpanded) {
                    btn.textContent = textLess;
                    btn.setAttribute('aria-expanded', 'true');
                    hiddenWrapper.setAttribute('aria-hidden', 'false');
                } else {
                    btn.textContent = textMore;
                    btn.setAttribute('aria-expanded', 'false');
                    hiddenWrapper.setAttribute('aria-hidden', 'true');
                }
            });
        }
    });
};

export default jamlMore;